var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.664062 10.5498C0.664062 5.02696 5.14121 0.549805 10.6641 0.549805H38.6641C44.1869 0.549805 48.6641 5.02696 48.6641 10.5498V38.5498C48.6641 44.0727 44.1869 48.5498 38.6641 48.5498H10.6641C5.14121 48.5498 0.664062 44.0727 0.664062 38.5498V10.5498Z",
    fill: "url(#paint0_linear_4168_5971)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6641 34.2807C23.9681 34.4562 24.313 34.5486 24.6641 34.5486C25.0151 34.5486 25.36 34.4562 25.6641 34.2807L32.6641 30.2807C32.9678 30.1053 33.2201 29.8532 33.3956 29.5495C33.5711 29.2459 33.6637 28.9014 33.6641 28.5507V20.5507C33.6637 20.2 33.5711 19.8555 33.3956 19.5518C33.2201 19.2482 32.9678 18.996 32.6641 18.8207L25.6641 14.8207C25.36 14.6451 25.0151 14.5527 24.6641 14.5527C24.313 14.5527 23.9681 14.6451 23.6641 14.8207L16.6641 18.8207C16.3603 18.996 16.108 19.2482 15.9325 19.5518C15.757 19.8555 15.6644 20.2 15.6641 20.5507V28.5507C15.6644 28.9014 15.757 29.2459 15.9325 29.5495C16.108 29.8532 16.3603 30.1053 16.6641 30.2807L23.6641 34.2807Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6641 34.5508V24.5508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9531 19.5508L24.6631 24.5508L33.3731 19.5508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1641 16.8203L29.1641 21.9703",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4168_5971",
    x1: 24.6641,
    y1: 0.549805,
    x2: 24.6641,
    y2: 48.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A5FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinger);
export default __webpack_public_path__ + "static/media/Singer.76bab0e13fe7029e0fc7a4ae0dca261b.svg";
export { ForwardRef as ReactComponent };